import { availableDevicesEnum, BankData, ProductAvailableDevices } from '@/screens/Credit/page/types'

import { HeroBannerInfoProps } from '@/widgets/HeroBannerInfo'

import {
	BasketIPort,
	HandbookBlueIPort,
	ShopingIPort,
	UserIPort,
	WalletBlueIPort
} from '@/shared/lib/@deprecated/iport-icons'
import { WEB_OFFER_LINK } from '@/shared/lib/utils/constants/pdfDocs'

export const heroBannerInfoData: HeroBannerInfoProps = {
	title: `Рассрочка и кредиты`,
	text: 'Не откладывайте приобретение товара — воспользуйтесь онлайн-кредитом или беспроцентной рассрочкой',
	image: {
		src: 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/screens/credit/hero.png',
		height: 205,
		width: 529,
		alt: ''
	},
	buttonLabel: '',
	additional: [
		{
			title: 'Удобное оформление',
			text: 'Короткая онлайн-анкета сразу в 12 банков'
		},
		{
			title: 'Быстрое одобрение',
			text: 'От заявки до решения от банков за 15 минут'
		},
		{
			title: 'Без первого взноса',
			text: 'Покупки сейчас — первый платеж через месяц'
		}
	],
	links: {
		business: {
			link: '/b2b/leasing/',
			text: 'Для бизнеса',
			isCurrent: false
		},
		regular: {
			link: '/services/credit/',
			text: 'Частным лицам',
			isCurrent: true
		}
	},
	onClick: () => {}
}

export const acceptedDevices: ProductAvailableDevices[] = [
	{
		label: `iPhone`,
		link: `/catalog/apple_iphone/`
	},
	{
		label: `iPad`,
		link: `/catalog/apple_ipad/`
	},
	{
		label: `MacBook Pro`,
		link: `/catalog/apple_mac/filter/macbook-pro/`
	},
	{
		label: `MacBook Air`,
		link: `/catalog/apple_mac/filter/macbook-air/`
	},
	{
		label: `Mac mini`,
		link: `/catalog/apple_mac/filter/mac-mini/`
	},
	{
		label: `iMac`,
		link: `/catalog/apple_mac/filter/imac/`
	},
	{
		label: `Apple Watch`,
		link: `/catalog/apple_watch/`
	}
]

export const stepsItemsShop = {
	online: [
		{
			icon: BasketIPort,
			title: `Выберите товар`,
			subtitle: `и оформите заказ на сайте`
		},
		{
			icon: WalletBlueIPort,
			title: `Выберите способ оплаты`,
			subtitle: `«Рассрочка» или «Кредит» при оформлении заказа`
		},
		{
			icon: HandbookBlueIPort,
			title: `Заполните анкету`,
			subtitle: `и дождитесь одобрения банка`
		},
		{
			icon: ShopingIPort,
			title: 'Подпишите документы',
			subtitle: 'и заберите покупку'
		}
	],
	offline: [
		{
			icon: BasketIPort,
			title: `Выберите товар`,
			subtitle: `выберете аксессуары`
		},
		{
			icon: UserIPort,
			title: `Обратитесь к сотруднику`,
			subtitle: `для подачи заявки на рассрочку или кредит`
		},
		{
			icon: HandbookBlueIPort,
			title: `Выберите кредитный продукт`,
			subtitle: `заполните заявку с сотрудником`
		},
		{
			icon: ShopingIPort,
			title: 'Подпишите документы',
			subtitle: 'и заберите товар'
		}
	]
}

export const faqItems = [
	{
		question: `Что нужно для оформления рассрочки или кредита?`,
		answer: `Для оформления вам понадобится паспорт РФ и обязательно наличие регистрации на территории РФ.`
	},
	{
		question: `Как оформить рассрочку онлайн?`,
		answer: `Выберите интересующий вас товар, продолжите оформление заказа в корзине и укажите способ оплаты : «Рассрочка».
`
	},
	{
		question: `Суммируются ли скидки с рассрочкой?`,
		answer: `Существуют акции, которые суммируются с рассрочкой. С актуальной информацией по рассрочкам можно ознакомиться в разделе «Акции».`
	},
	{
		question: `Возможно ли оформить рассрочку с обменом в Трейд-ин?`,
		answer: `Существуют акции, которые допускают возможность оформления товара в рассрочку используя программу обмен в Трейд-ин. Подробнее с программой можно ознакомиться в разделе «Обмен в Трейд-ин».`
	},
	{
		question: `Может ли иностранец оформить рассрочку?`,
		answer: `Нет, оформить рассрочку может только гражданин РФ.`
	},
	{
		question: `Распространяются ли условия рассрочки на юридические лица?`,
		answer: `К сожалению, нет. Рассрочку можно оформить только на физическое лицо и ИП.`
	},
	{
		question: `Может ли пенсионер оформить рассрочку?`,
		answer: `Оформить рассрочку может клиент в возрасте от 18 до 75 лет в зависимости от выбранного предложения.`
	},
	{
		question: `Можно ли внести сразу большую часть суммы, а рассрочку оформить на остаток?`,
		answer: `Вы можете оформить рассрочку на сумму от 1 000 рублей до 700 000 рублей, в зависимости от выбранного предложения.`
	},
	{
		question: `Возможна ли рассрочка при предзаказе?`,
		answer: `К сожалению, нет. Рассрочку можно оформить только на товар, который имеется в наличии.`
	},
	{
		question: `Возможно ли купить два iPhone в рассрочку на одного человека?`,
		answer: `Да, такая возможность есть. В данном случае автоматически будет выбрана программа рассрочки с наименьшим сроком. С актуальными программами можно ознакомиться в разделе «Рассрочки».`
	},
	{
		question: `Где можно оформить рассрочку?`,
		answer: `Вы можете оформить рассрочку в любом из наших магазинов или на сайте iport.ru. С адресами магазинов вы можете ознакомиться подробнее в разделе «Магазины». Для увеличения срока кредитования вы можете оформить карту преимуществ iPort+ . Подробнее Вы можете узнать в разделе <a href="/services/plus/">«iPort +»</a>.`
	},
	{
		question: `В каком банке лучше оформить рассрочку?`,
		answer: `Мы сотрудничаем с крупнейшими банками РФ: МТС Банк, Тинькофф Банк, Кредит Европа Банк, Совкомбанк и другими. Наши кредитные специалисты помогут вам подобрать наиболее подходящее предложение по рассрочке. Подробности по кредитным предложениям вы можете получить в любом из наших магазинов. Узнать адреса можно в разделе <a href="/shops/">«Магазины»</a>, а также по телефону горячей линии <a href="tel:8 800 77-000-97">8 800 77-000-97</a>. <a title="Смотреть" target="_blank" href="https://api.iport.ru/files/pdf/banks-partners.pdf">Полный перечень банков-партнёров.</a>`
	},
	{
		question: `Кто может оформить рассрочку?`,
		answer: `Рассрочка предоставляется гражданину РФ, в возрасте от 18 до 75 лет (возможно оформление пенсионерам) на сумму от 1 000 рублей до 300 000 рублей. Подробности по кредитным программам и программам рассрочки вы можете уточнить на сайте iport.ru в разделе «Рассрочки».`
	},
	{
		question: `Какие товары можно приобрести в рассрочку?`,
		answer: `В рассрочку можно приобрести практически все товары, представленные на нашем сайте iport.ru. Подробности по перечню товаров, доступных в рассрочку вы можете уточнить в разделе «Рассрочки». Если на товар не распространяется рассрочка, то такой товар можно оформить в кредит.`
	}
]

export const bankData: { online: BankData[]; offline: BankData[] } = {
	online: [
		{
			title: 'Кредит',
			pic: {
				src: '/assets/credit/banks/credit-banks.svg',
				alt: 'Банки-партнёры: Ренессанс Кредит, Совкомбанк, Альфа-Банк, МТС-Банк, Т-Банк',
				width: 192,
				height: 48
			},
			percent: 'Формируется банком в итоговом предложении',
			initialFee: '0%',
			sum: '1000 — 300 000 ₽',
			term: '6 — 36 месяцев',
			availableDevices: availableDevicesEnum.All
		},
		{
			title: 'Рассрочка',
			pic: {
				src: '/assets/credit/banks/installment-banks.svg',
				alt: 'Банки-партнёры: МТС-Банк, Совкомбанк, Т-Банк, Кредит Европа Банк, Ренессанс Кредит, Альфа-Банк',
				width: 228,
				height: 48
			},
			percent: '0%',
			initialFee: '0%',
			sum: '1000 — 300 000 ₽',
			term: '6 — 24 месяцев',
			extraNode: {
				text:
					'Ставка от 9.28% до\n' +
					'\t\t\t\t21.6% (рассрочка предоставляется с небольшим удорожанием, за счёт скидки продавца от 3.5% до 12% от стоимости\n' +
					'\t\t\t\tтовара. Общая сумма переплаты за рассрочку может составлять от 1% до 10%, в зависимости от предложения'
			},
			availableDevices: acceptedDevices
		}
	],
	offline: [
		{
			title: 'Кредит',
			pic: {
				extraBanks: {
					src: '/assets/credit/banks/extra-banks.svg',
					alt: 'Ещё банки-партнёры: Банк Русский Стандарт, Почта Банк, Кредит Европа Банк, Т-Банк',
					width: 156,
					height: 48
				},
				src: '/assets/credit/banks/credit-banks-offline.svg',
				alt: 'Банки-партнёры: Ренессанс Кредит, Совкомбанк, Альфа-Банк, МТС-Банк, ОТП Банк и ещё 4',
				width: 228,
				height: 48
			},
			percent: 'Формируется банком в итоговом предложении',
			initialFee: '0%',
			sum: '1000 — 300 000 ₽',
			term: '6 — 36 месяцев',
			availableDevices: availableDevicesEnum.All
		},
		{
			title: 'Рассрочка',
			pic: {
				src: '/assets/credit/banks/installment-banks-offline.svg',
				alt: 'Банки-партнёры: МТС-Банк, Совкомбанк, Т-Банк, Кредит Европа Банк, Ренессанс Кредит, Альфа-Банк',
				width: 228,
				height: 48
			},
			percent: '0%',
			initialFee: '0%',
			sum: '1000 — 300 000 ₽',
			term: '6 — 24 месяцев',
			extraNode: {
				text: 'Рассрочка сроком более 6 месяцев, доступна при условии покупки карты преимуществ iPort+',
				link: { text: 'Узнать о карте', href: '/' }
			},
			availableDevices: acceptedDevices
		}
	]
}

export const pdfList = [
	{
		title: `Договор оферта`,
		link: WEB_OFFER_LINK
	}
]
